import { assets as assetConstants } from '@picsio/db/src/constants';

/** Extensions Shopify accepts as native IMAGE / VIDEO / MODEL_3D uploads. */
export const SHOPIFY_NATIVE_EXTENSIONS = {
  jpg: 'IMAGE',
  jpeg: 'IMAGE',
  png: 'IMAGE',
  gif: 'IMAGE',
  webp: 'IMAGE',
  svg: 'IMAGE',
  bmp: 'IMAGE',
  heic: 'IMAGE',
  mp4: 'VIDEO',
  mov: 'VIDEO',
  glb: 'MODEL_3D',
  usdz: 'MODEL_3D',
};

/**
 * Formats for which thumbnailer can generate a custom thumbnail that publish may
 * use as a Shopify IMAGE substitute. Sourced from `@picsio/db` thumbnailing jobs
 * (PSD/TIFF/EPS, RAW, Illustrator, InDesign). Excludes video/3D — no Shopify
 * thumbnail-fallback path for those (PCS-11014 Scope 12).
 */
const { thumbnailing } = assetConstants;
export const SHOPIFY_PREPARE_THUMBNAIL_EXTENSIONS = new Set([
  ...(thumbnailing.PSDThumbnailingJob || []),
  ...(thumbnailing.RAWThumbnailingJob || []),
  ...(thumbnailing.AiThumbnailingJob || []),
  ...(thumbnailing.InDesignThumbnailingJob || []),
].map((ext) => String(ext).toLowerCase()));

function getExtension(asset = {}) {
  if (asset.fileExtension) {
    return String(asset.fileExtension).replace(/^\./, '').toLowerCase();
  }
  const name = asset.name || '';
  const dot = name.lastIndexOf('.');
  if (dot < 0) return '';
  return name.slice(dot + 1).toLowerCase();
}

function getShopifyNativeType(asset) {
  return SHOPIFY_NATIVE_EXTENSIONS[getExtension(asset)] || null;
}

/**
 * Whether thumbnailer can prepare a Shopify-compatible IMAGE version for this asset.
 */
export function canThumbnailerPrepareShopifyVersion(asset = {}) {
  const ext = getExtension(asset);
  return Boolean(ext) && SHOPIFY_PREPARE_THUMBNAIL_EXTENSIONS.has(ext);
}

/**
 * True when listing/channel attach should show "Prepare media for Shopify":
 * non-Shopify-native format that thumbnailer can convert to a JPG thumbnail.
 */
export default function needsShopifyPrepareFormat(asset) {
  if (!asset) return false;
  if (getShopifyNativeType(asset)) return false;
  return canThumbnailerPrepareShopifyVersion(asset);
}

export function filterAssetsNeedingShopifyPrepare(assets = []) {
  return assets.filter(needsShopifyPrepareFormat);
}
